<template lang="pug">
  #app
    .fixed.right-0.top-0.mt-32.max-w-sm.z-50
      transition-group(name="slide")
        Notification(v-for="notification in notifications" :notification="notification" :key="notification.id")
    
    Header
    transition(name="fade")
      router-view(class="lg:px-4" v-if="ready")
    transition(name="fade")
      Loader(v-if="isSigningIn" :info="'Signing you in...'")
      //Loader(v-if="isSigningOut" :info="'See ya soon 👋🏾'")
    
</template>

<script>
import Loader from "./components/Loader";
import Notification from "./components/Notification";
import Header from "./components/Header";
import { mapGetters } from "vuex";
import { auth } from "./firebase.config";

export default {
  name: "App",
  components: { Loader, Notification, Header },
  computed: {
    ...mapGetters([
      "isSigningIn",
      "notifications",
      "isSigningOut",
      "updates",
      "keyResults"
    ]),
    ready() {
      return !this.isSigningIn ||
        this.$route.name == "signIn" ||
        this.$route.name == "signUp" ||
        this.$route.name == "invite" ||
        this.$route.name == "password"
        ? true
        : false;
    }
  },
  watch: {
    ready(val) {
      if (val) {
        const user = auth.currentUser;

        if (user) {
          window.Intercom("boot", {
            app_id: "g17yrqpq",
            user_id: user.uid,
            name: user.displayName,
            email: user.email
          });
          heap.identify(user.uid);
          heap.addUserProperties({ Name: user.displayName, email: user.email });
        }
      }
    }
  }
};
</script>
<style lang="sass"></style>
